export default [
  {
    path: '/landing/h5-credit',
    component: () => import('../view/landing/h5-credit'),
    name: 'h5-credit',
    meta: { pageName: 'page_h5_credit' }
  },
  {
    path: '/landing/h5-credit-result',
    component: () => import('../view/landing/h5-credit/result'),
    name: 'h5-credit-result',
    meta: { pageName: 'page_h5_credit' }
  },
  {
    path: '/authentication/id-h5-credit',
    component: () => import('../view/authentication/id-h5-credit'),
    name: 'id-h5-credit',
    meta: { pageName: 'page_id_h5_credit' }
  },
  {
    path: '/authentication/base-h5-credit',
    component: () => import('../view/authentication/base-h5-credit'),
    name: 'base-h5-credit',
    meta: { pageName: 'page_base_h5_credit' }
  }
   
  
]